import { supabase } from './supabase';

export interface LeavePersonnel {
    id: string;
    name: string;
    user_id: string | null;
    branch_id: string | null;
}

export async function fetchLeavePersonnel(branchId?: string, isAdmin = false) {
    let query = supabase.from('leave_personnel')
        .select('id, name, user_id, branch_id').eq('is_active', true).order('name');
    if (branchId && !isAdmin) query = query.eq('branch_id', branchId);
    const { data, error } = await query;
    if (error) throw error;
    return (data || []) as LeavePersonnel[];
}

export function belongsToPersonnel(
    leave: { personnel_id?: string | null; user_id: string | null; personnel_name?: string },
    person: LeavePersonnel
) {
    if (leave.personnel_id) return leave.personnel_id === person.id;
    if (leave.user_id) return leave.user_id === person.user_id;
    // Names are not identities: a replacement may have the same name.
    return false;
}
